<template>
    <Header></Header>
    <div class="LocationBar"><div class="inner"><ul class="Location"><li class="Location__item home"><a href="" class="Location__item--btn"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVQ4ja3TP0sDQRAF8J+HiGAKLQVFsbIQ4p/SRrDKB0hhZyXYiFjnQ9jZCJYigo2CRUDBNkr8ArGytRAUooVaZALHceeZ4IOFtzPz3s4uOyP1el0JFnAafAtPvxUnJWZ1tPEYqx2xQowWxMdxGB3t4CziNzjGJvbR/UuHi2hhDaspM8FXI9eK2l8Nt3GPJtbRyTmwE7lm1G6nk/0rV3CEmt41L3OM0vjEAW5xovcEu3hLsIwHzAcvM0vjMjTz4bGcROvn2MDzAGZ9PIf2HM0EM2jgAtUhDKuhbWB2FB+RmMNUjmAEK8Hb+M7kp0IL3aJ/2McErjOGNbwXCcomZVfvB0zHqkSsEGUdLuEKb7G/ilghyjqErwI+tOFA+HfD7BtWMJnaj+VoxjI1lSLDV/ljt5fiL3qzvpWpueuTH1quOlOE3j3aAAAAAElFTkSuQmCC" alt=""></a></li><li class="Location__item"><a href="javascript:;" class="Location__item--btn"><p>퍼블팀</p><span></span></a><div class="Location__item--Layer"><ul><li><a href="/hospital/department-doctor/department.do" class="">진료과/의료진</a></li><li><a href="/hospital/reservation/appointment.do" class="">예약/발급</a></li><li><a href="/hospital/information/outpatient.do" class="">이용안내</a></li><li><a href="/hospital/healthInfo/consulting.do" class="">건강정보</a></li><li><a href="/hospital/hospitalIntro/fatima/greetings.do" class="">병원소개</a></li></ul></div></li><li class="Location__item"><a href="javascript:;" class="Location__item--btn"><p>작업</p><span></span></a><div class="Location__item--Layer"><ul><li><a href="/hospital/hospitalIntro/fatima/greetings.do" class="">창원파티마병원</a></li><li><a href="/hospital/hospitalIntro/story/newsBoard.do" class="">파티마이야기</a></li><li><a href="/hospital/hospitalIntro/active/prayBoard.do" class="">병원활동</a></li></ul></div></li><li class="Location__item"><a href="javascript:;" class="Location__item--btn"><p>화이팅</p><span></span></a><div class="Location__item--Layer"><ul><li><a aria-current="page" href="/kr/news/list.do" class="router-link-active router-link-exact-active">화이팅</a></li><li><a href="/kr/press/list.do" class="">언론보도</a></li><li><a href="/kr/event/list.do" class="">행사안내</a></li><li><a href="/kr/job/list.do" class="">퍼블팀</a></li><li><a href="https://fliphtml5.com/bookcase/nrkwy/" to="https://fliphtml5.com/bookcase/nrkwy/">파티마 웹진</a></li><li><a href="/kr/gallery/list.do" class=""></a></li></ul></div></li></ul></div></div>
    <!-- <div class="my-page__tab">
        <ul class="my-page__list">
            <li class="my-page__item">
                <a href="javascript:;">예약조회</a>
            </li>
            <li class="my-page__item">
                <a href="javascript:;">결과조회</a>
            </li>
              <li class="my-page__item">
                <a href="javascript:;">나의 작성글</a>
            </li>
              <li class="my-page__item active">
                <a href="javascript:;">나의 건강관리</a>
            </li>
              <li class="my-page__item">
                <a href="javascript:;">즐겨찾기</a>
            </li>
              <li class="my-page__item">
                <a href="javascript:;">회원정보수정</a>
            </li>
        </ul>
    </div> -->
    <div class="container">
        <div class="sub-tit">
            <h2>작업공간</h2>
        </div>
        <div class="inner">
            <Work></Work>
        </div>
    </div>
    <Footer></Footer>
</template>

<script>
    import Header from '@/components/common/Header.vue';
    import LocationBar from '@/components/common/LocationBar.vue';
    import Work from '@/components/퍼블팀/샘플/Work.vue';
    import Footer from '@/components/common/Footer.vue';

    export default {
        components: {
            Header,
            LocationBar,
            Work,
            Footer
        },
        mounted() {
            console.log(123)
            // AOS 초기화 (옵션에 맞게 필요 시 업데이트)
            // this.$nextTick(() => {
            //     this.AOS.refresh()
            // });
        },
    }
</script>
<style>
    /* @import url('../../assets/resource/css/sub.css'); */
</style>